export const HYPERTEST_CONCURRENCY_ACTIONS_REQUEST =
  'HYPERTEST_CONCURRENCY_ACTIONS_REQUEST';
export const HYPERTEST_CONCURRENCY_ACTIONS_RESPONSE =
  'HYPERTEST_CONCURRENCY_ACTIONS_RESPONSE';
